import React from 'react';
import { Card, CardContent } from '../ui/card';
import { UserCheck, TestTube, Plane, DollarSign, Clock, ArrowRight } from 'lucide-react';

const HowItWorksSection = () => {
  const steps = [
    {
      number: 1,
      icon: UserCheck,
      title: "Apply Online",
      description: "Submit application and documentation"
    },
    {
      number: 2,
      icon: TestTube,
      title: "Verification",
      description: "Local Lawyer and Agent team validates gold and licences"
    },
    {
      number: 3,
      icon: Plane,
      title: "Export",
      description: "We handle all logistics and customs"
    },
    {
      number: 4,
      icon: DollarSign,
      title: "Payment",
      description: "Secure payment after final validation"
    }
  ];

  return (
    <section id="how-it-works" className="py-24 bg-[#040F2D]">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-20">
          <div className="flex items-center justify-center mb-8">
            <Clock className="h-10 w-10 text-[#D4AF37] mr-4" />
            <h2 className="text-5xl font-bold text-white">How It Works</h2>
          </div>
          <p className="text-xl text-white/70 max-w-3xl mx-auto">
            Simple, secured, and transparent process from the application to payment
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => {
            const IconComponent = step.icon;
            return (
              <div key={index} className="relative">
                <Card className="text-center border border-white/10 shadow-lg hover:shadow-xl transition-all duration-300 bg-[#0B132B]/60">
                  <CardContent className="p-6">
                    <div className="mb-4">
                      <div className="w-16 h-16 bg-gradient-to-br from-[#040F2D] to-[#0B132B] rounded-xl flex items-center justify-center mx-auto mb-3 shadow-md">
                        <span className="text-white font-bold text-xl">{step.number}</span>
                      </div>
                    </div>
                    <h3 className="text-lg font-bold text-white mb-2">
                      {step.title}
                    </h3>
                    <p className="text-white/70 text-sm">
                      {step.description}
                    </p>
                  </CardContent>
                </Card>
                
                {/* Arrow connector for larger screens - pointing RIGHT */}
                {index < steps.length - 1 && (
                  <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                    <ArrowRight className="h-6 w-6 text-[#D4AF37]" />
                  </div>
                )}
              </div>
            );
          })}
        </div>

        <div className="mt-16 text-center">
          <div className="bg-gradient-to-r from-[#D4AF37]/10 to-[#C5A059]/10 rounded-xl p-6 border border-[#D4AF37]/30">
            <p className="text-lg text-white font-semibold">
              💡 <strong>Timeline:</strong> 5 working days maximum
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;